export const SECONDARY_Y_AXIS_TYPES = {
  RESERVES_ACQUIRED: 'Reserves Transacted (MMboe)',
  PRICE_PAID: 'Price Paid ($/boe)',
};

export const secondaryYAxis = Object.values(SECONDARY_Y_AXIS_TYPES).map((name) => name);
